import styled from "styled-components";

const LightText = styled.div`
  color: var(--dusty-gray);
`;

export default LightText;
